/**
 * @typedef {string|*} Constants
 */

/**
 * Enum for Constant values
 * @enum {Constants}
 */
export const Constants = {
    OPENERTS: "openerTS",
    OPENERDISPLAY: "oDI",
    ASYNC_LAST: "last",
    CONFERENCE: "conference",
    TRANSFER: "transfer",
    RECONNECTED: "reconnected",
    KEY_ENTER: 13,
    KEY_PROCESS: 229,
    INVALID_CLASS: "invalid",
    EMAIL_REQ: "emailReq",
    SOUND_STATE: "soundState",
    CLIENT_OUT: "co",
    CUSTOMER_DISPLAY_NAME: "ci_cdn",
    DATA_SURVEY_URL: "data-survey-url",
    EA: "#EmptyAnswer",
    VA_TYPING_TIMER: "vaTypingTimer",
    IS_FULL_SCREEN: "fullScreenOnly",
    WITHIN_BOTTOM: "withinBottom",
    WITHIN_TOP: "withinTop",
    WIDGET_ACTION_REMOVE: "Remove",
    RM: "richMedia",
    SCROLL_BTN_TIMER_NAME: "scrollBtnTimer",
    OK: "Ok",
    CANCEL: "Cancel",
    AGENT_OR_RICH_MEDIA_MESSAGE_RENDERED: "agentOrRichMediaMessageRendered",

    // video call related constants
    CALL_STATE: "cls",
    VIDEO_AUDIO_CALL_INVITATION: "voc",
    CALL_STATE_VIDEO_INVITE: 1,
    CALL_STATE_VOICE_INVITE: 2,
    ROOM_JOINED: "joined",
    RTC_ERROR: "error",
    UNREAD_COUNT: "urc",
    AGENT_VIDEO_ERROR: "agentVideoError",
    AGENT_VIDEO_PUBISHED: "agentVideoPublished",
    LOCAL_AUDIO_ERROR: "localAudioError",
    LOCAL_VIDEO_ERROR: "localVideoError",
    CUSTOMER_VIDEO_PUBISHED: "localVideoPublished",
    ENABLED_CUSTOMER_CAMERA: "customerCameraEnabled",
    ENABLED_VOICE_ONLY_CALL: "voiceOnlyCall",

    // video call related constants - end
    NETWORK_MSG_TIMER: "networkMsgTimer",
    VIRTUAL_KEYBOARD_DISPLAYED: "virtualkeyboard.displayed",
    WINDOW_RESIZED: "window.resized",
    CHAT_WINDOW_RESTORED: "chatWindowRestored",

    // phone zoom level when device pixel ratio is equal to css pixes ie 1 CSS PX is equal to I Device Independend Pixel
    ZOOM_LEVEL_PORTRAIT: 1,

    /*
     * in landscape since Device width is greater than the view port max width ie 800px,
     * page is zoomed to reach the device width ie 1 CSS px is nearly equal to 1.2 device pixel
     */
    ZOOM_LEVEL_LANSDCAPE: 1.2,
    MINIMIZED_COUNT: "mc",
    MESSAGE_COUNT: "msgcnt",
    CHAT_ENGAGED: "eng",
    DEFAULT_DATE_FORMAT: "MMM DD YYYY",
    DEFAULT_TIMESTAMP_FORMAT: "HH:mm",
    NUANCE_MESSAGE_TEXT: "data-nuance-message-text",
    NUANCE_MESSAGE_DATA: "data-nuance-message-data",
    NUANCE_DATAPASS: "data-nuance-datapass",

    // Masking tags for sendDataPass
    MASKING_START_TAG: "((masked{[",
    MASKING_END_TAG: "]}masked))",
};

/**
 * @typedef {string} MessageTypes
 */

/**
 * Enum for MessageTypes
 * @enum {MessageTypes}
 */
export const MessageType = {
    TYPE_CHATLINE: "chatLine",
    TYPE_CHAT_COMMUNICATION: "chat.communication",
    TYPE_CHAT_COMMUNICATION_OPENER: "chat.communication.opener",
    TYPE_CHAT_COMMUNICATION_OUTCOME: "chat.communication_outcome",
    TYPE_CHAT_ACTIVITY: "chat.activity",
    TYPE_CHAT_NEED_WAIT: "chat.need_wait",
    TYPE_CHAT_ACCEPTED: "chat.accepted",
    TYPE_CHAT_AUTHORIZED: "chat.authorized",
    TYPE_CHAT_EXIT: "chat.exit",
    TYPE_CHAT_DENIED: "chat.denied",
    TYPE_CHAT_TRANSFER_RESPONSE: "chat.transfer_response",
    TYPE_CHAT_COMMUNICATION_QUEUE: "chat.communication.queue",
    TYPE_CHATROOM_MEMBER_LOST: "chatroom.member_lost",
    TYPE_CHATROOM_MEMBER_CONNECTED: "chatroom.member_connected",
    TYPE_NINA_COACH_CHAT_TAKE_OVER: "nina.coach.chat.take.over",
    TYPE_CHAT_AUTOMATON_REQUEST: "chat.automaton_request",
    TYPE_CHAT_COMMUNICATION_SURVEY: "chat.communication.survey",
    TYPE_CHAT_AUTHENTICATED_USER_RESPONSE: "authenticated.user.response",
    TYPE_CHAT_COBROWSE: "chat.cobrowse",
    TYPE_CLIENT_COMMAND: "client.command",
};

/**
 * @typedef {string} KEY_TYPE
 */

/**
 * Enum for message properties
 * @enum {KEY_TYPE}
 */
export const KEY_TYPE = {
    KEY_MESSAGE_TYPE: "messageType",
    KEY_FINAL_TEXT: "chatFinalText",
    KEY_MESSAGE_TIMESTAMP: "messageTimestamp",
    KEY_TIMESTAMP: "timestamp",
    KEY_TYPE: "type",
    KEY_ISAGENTMSG: "isAgentMsg",
    KEY_SENDER_NAME: "senderName",
    KEY_CLIENT_DISPLAY: "client.display.text",
    KEY_DISPLAY_TEXT: "display.text",
    KEY_CHAT_REINIT: "ChatReInited",
    KEY_TY_LABEL: "thank_you_image_label",
    KEY_TC_MODE: "tc.mode",
    KEY_CHAT_AUTOMATON_DATA: "automaton.data",
    KEY_MSG_AGENT_ALIAS: "agent.alias",
    KEY_CHATROOM_MEMBER_NAME: "chatroom.member.name",
    KEY_MSG_CUSTOMER_ALIAS: "customerAlias",
    KEY_MSG_TEXT: "messageText",
    KEY_AGENT_ID: "agentID",
    KEY_MESSAGE_DATA: "messageData",
    KEY_FORCED_CLOSE: "forced_close",
    QUEUE_AGENT_ALIAS: "config.agent_alias",
    CHAT_REPLAY: "chat.replay",
    KEY_WINDOW_ID: "windowId",
    KEY_COMMAND_PARAM: "chat.cmd",
    KEY_ENGAGEMENT_ID: "engagementID",
    KEY_CONVERSATION_ID: "conversationID",
    KEY_CONVERSATION_Id: "conversationId",
    KEY_EXTERNAL_APP: "external.app",
    KEY_AUTO_TRANSFER_IGNORED_CHATROOM: "auto_transfer_ignored_chatroom",
    KEY_CONFIG_V3_TIMEOUT: "config.v3_timeout"
};

/**
 * @typedef {string} SYSTEM_STATE
 * Enum for system bubble message state
 * @enum {SYSTEM_STATE}
 */

export const SYSTEM_STATE = {
    QUEUE_MSG: "queued",
    DENIED_MSG: "denied",
    EXIT_MSG: "exit",
    TRANSFER_STARTED: "transferInit",
    TRANSFER_JOINED: "transferJoined",
    LOST: "lost",
    CONFERENCE: "conf",
    NETWORK_FAILED: "networkFailed",
    NETWORK_DISCON: "networkDisconnected",
    NETWORK_RECON: "networkReconnected",
    FILE_UPLOAD_SUCCESS: "uploadSuccess",
    LOADING_MSG: "loading",
};

/*
 * @typedef {string} TYPING_STATE
 */
export const TYPING_STATE = {
    TYPING: "typing",
    STOPPED_TYPING: "notTyping",
};

export const CHAT_STATE = {
    STARTING: "STARTING",
    PRECHAT: "PRECHAT",
    ENGAGED: "ENGAGED",
    ENDED: "ENDED",
    PRECALL: "PRECALL",
    INCALL: "INCALL",
};

export const EMAIL_STATE = {
    DISABLED: 1,
    REQUESTED: 2,
};

export const RICH_WIDGET = {
    TYPE_RECEIPT: "receipt",
    TYPE_QR: "quickreply",
    TYPE_CARD: "card",
    TYPE_FORM: "form",
    INLINE: "inline",
};

export const STATUS_STATE = {
    LIVE_AGENT: 1,
    VA_AGENT: 2,
    QUEUE: 3,
    DISCONNECT: 4,
    CONFERENCE: 5,
};

export const FOOTER_STATES = {
    TYPING: "textEntered",
    ALWAYS: "always",
    INPUT: "inputEnabled",
};

export const CHAT_COMMANDS = {
    SHOW_UPLOAD_CMD: "grow.fileupload",
    HIDE_UPLOAD_CMD: "hide.fileupload",
};

export const CALL_MESSAGE_TYPE = {
    INVITATION: "callInvitation",
    NEW_CALL: "newCallRequest",
    NEW_VOICE_ONLY_CALL: "newVoiceCallRequest",
    ROOM_READY: "createRoomSuccess",
    ROOM_FAILED: "createRoomFailed",
    CALL_ENDED: "callEnded",
    ROOM_AGENT_JOIN: "roomAgentJoin",
    ROOM_AGENT_LEAVE: "roomAgentLeave",
};

export const CALL_STATE = {
    CALL_ENDED: 0, // default state
    PRE_CALL_SETUP: 1, // Pre call instruction screens
    CALL_INVITED: 2, // CI send call request invitation to agent
    ROOM_JOINED: 3, // Room created and customer joined
    CUSTOMER_PUBLISHED: 4, // Customer published video,
    AGENT_PUBLISHED: 5, // Agent stream received
    CALL_ERROR: 6, // error that during call setup
};

export const TOGGLE_SOUND = {
    SOUND_ON: "on",
    SOUND_OFF: "off",
};

export const ORIENTATION = {
    PORTRAIT: "portrait",
    LANDSCAPE: "landscape",
};

export const FOCUS_SETTINGS = {
    ON_INPUT: "onInput",
    ON_INTERACTIVE_ELEMENT: "onInteractiveElement",
    ON_NEW_AGENT_MESSAGE: "onNewAgentMessage",
};

export const FOCUS_ON_OPEN = {
    NONE: "none",
    ON_INPUT: "onInput",
    ON_OPENER: "onOpener",
};

export const NEW_PAGE_MINIMIZED = {
    ALL: "all",
    MOBILE: "mobile",
    PHONE: "phone",
};

export const UI_COMPONENT = {
    AGENT_SIMPLE_VIEW: "agent-simple-view",
    CUSTOMER_SIMPLE_VIEW: "customer-simple-view",
    HEADER_VIEW: "header-view",
    DISCLAIMER_VIEW: "disclaimer-view",
    SYSTEM_VIEW: "system-view",
    TYPING_VIEW: "typing-view"
};

export const WILD_CARDS = {
    CUSTOMER_NAME: "%CUSTOMER_NAME"
}